<template lang="pug">
div(ref="canvasContainer")
</template>

<script>
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

export default {
  props: {},
  created() {
    this.scene = new THREE.Scene();

    this.camera = new THREE.PerspectiveCamera(45, 1, 0.01, 1000);
    this.camera.position.set(10, 8, 3);
    this.camera.lookAt(0, 0, 0);
    this.scene.add(this.camera);

    this.renderer = new THREE.WebGLRenderer({ antialias: true });
    this.renderer.setPixelRatio(window.devicePixelRatio);

    this.canvas = this.renderer.domElement;
    this.canvas.style.width = "100%";
    this.canvas.style.height = "100%";
    this.clock = new THREE.Clock(false);

    this.controls = new OrbitControls(this.camera, this.canvas);
    window.three = this;
  },
  mounted() {
    this.$refs.canvasContainer.append(this.canvas);

    this.onResize = () => {
      const width = this.$refs.canvasContainer.clientWidth;
      const height = this.$refs.canvasContainer.clientHeight;
      this.width = width;
      this.height = height;
      this.renderer.setSize(width, height);
      this.camera.aspect = width / height;
      this.camera.updateProjectionMatrix();
      this.$emit("resize", this, width, height);
    };
    this.onResize();
    window.addEventListener("resize", this.onResize);

    this.$emit("init-scene", this);

    this.clock.start();
    this.renderer.setAnimationLoop(() => this.tick());
  },
  methods: {
    tick() {
      this.$emit("tick", this, this.clock.getDelta());

      this.renderer.render(this.scene, this.camera);
    },
  },
  destroyed() {
    this.renderer.setAnimationLoop(null);
    this.canvas.remove();
    window.removeEventListener("resize", this.onResize);
  },
};
</script>